/**
 * react-hot-toast(내부 goober)는 임포트 시점에 document 를 만진다.
 * 스토어·authoring 계층은 node 환경(테스트)에서도 로드되므로, 토스트가
 * 실제로 필요해지는 순간에만 동적 임포트한다. 표시는 fire-and-forget —
 * 실패해도 호출부의 본 동작(삭제·실행)을 막지 않는다.
 */
export function showToast(
  message: string,
  opts?: { icon?: string; duration?: number },
): void {
  void import('react-hot-toast')
    .then(({ default: toast }) => toast(message, opts))
    .catch(() => {});
}
